export default __webpack_public_path__ + "static/media/smartphone.8bee7579.svg";